import { render, staticRenderFns } from "../modules/Case2.0/template/create-case2.html?vue&type=template&id=66c2803b&scoped=true&"
import script from "../modules/Case2.0/script/create-case.ts?vue&type=script&lang=js&"
export * from "../modules/Case2.0/script/create-case.ts?vue&type=script&lang=js&"
import style0 from "../modules/Case2.0/style/create-case.scss?vue&type=style&index=0&id=66c2803b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2803b",
  null
  
)

export default component.exports